import React from "react";
import MuiSwitch from "@mui/material/Switch";

import { useSwitchStyles } from "./SwitchStyles";
import { SwitchProps } from "./Switch.types";

function Switch(props: SwitchProps): JSX.Element {
  const { color = "primary", ...other } = props;

  const switchClasses = useSwitchStyles();

  return (
    <MuiSwitch
      {...other}
      classes={switchClasses}
      color={color}
      disableRipple
      disableFocusRipple
      disableTouchRipple
    />
  );
}

export default Switch;
